export default __webpack_public_path__ + "static/media/R5C_8226.be083a14.jpg";